// Constants from ESP-IDF C Header: components\bt\common\btc\profile\esp\blufi\include\blufi_int.h

// Packet type
export const BLUFI_TYPE_CTRL = 0x0;
export const BLUFI_TYPE_DATA = 0x1;

// Control subtype
export const BLUFI_TYPE_CTRL_SUBTYPE_ACK = 0x00;
export const BLUFI_TYPE_CTRL_SUBTYPE_SET_SEC_MODE = 0x01;
export const BLUFI_TYPE_CTRL_SUBTYPE_SET_WIFI_OPMODE = 0x02;
export const BLUFI_TYPE_CTRL_SUBTYPE_CONN_TO_AP = 0x03;
export const BLUFI_TYPE_CTRL_SUBTYPE_DISCONN_FROM_AP = 0x04;
export const BLUFI_TYPE_CTRL_SUBTYPE_GET_WIFI_STATUS = 0x05;
export const BLUFI_TYPE_CTRL_SUBTYPE_DEAUTHENTICATE_STA = 0x06;
export const BLUFI_TYPE_CTRL_SUBTYPE_GET_VERSION = 0x07;
export const BLUFI_TYPE_CTRL_SUBTYPE_DISCONNECT_BLE = 0x08;
export const BLUFI_TYPE_CTRL_SUBTYPE_GET_WIFI_LIST = 0x09;

// Data subtype
export const BLUFI_TYPE_DATA_SUBTYPE_NEG = 0x00;
export const BLUFI_TYPE_DATA_SUBTYPE_STA_BSSID = 0x01;
export const BLUFI_TYPE_DATA_SUBTYPE_STA_SSID = 0x02;
export const BLUFI_TYPE_DATA_SUBTYPE_STA_PASSWD = 0x03;
export const BLUFI_TYPE_DATA_SUBTYPE_SOFTAP_SSID = 0x04;
export const BLUFI_TYPE_DATA_SUBTYPE_SOFTAP_PASSWD = 0x05;
export const BLUFI_TYPE_DATA_SUBTYPE_SOFTAP_MAX_CONN_NUM = 0x06;
export const BLUFI_TYPE_DATA_SUBTYPE_SOFTAP_AUTH_MODE = 0x07;
export const BLUFI_TYPE_DATA_SUBTYPE_SOFTAP_CHANNEL = 0x08;
export const BLUFI_TYPE_DATA_SUBTYPE_USERNAME = 0x09;
export const BLUFI_TYPE_DATA_SUBTYPE_CA = 0x0a;
export const BLUFI_TYPE_DATA_SUBTYPE_CLIENT_CERT = 0x0b;
export const BLUFI_TYPE_DATA_SUBTYPE_SERVER_CERT = 0x0c;
export const BLUFI_TYPE_DATA_SUBTYPE_CLIENT_PRIV_KEY = 0x0d;
export const BLUFI_TYPE_DATA_SUBTYPE_SERVER_PRIV_KEY = 0x0e;
export const BLUFI_TYPE_DATA_SUBTYPE_WIFI_REP = 0x0f;
export const BLUFI_TYPE_DATA_SUBTYPE_REPLY_VERSION = 0x10;
export const BLUFI_TYPE_DATA_SUBTYPE_WIFI_LIST = 0x11;
export const BLUFI_TYPE_DATA_SUBTYPE_ERROR_INFO = 0x12;
export const BLUFI_TYPE_DATA_SUBTYPE_CUSTOM_DATA = 0x13;
export const BLUFI_TYPE_DATA_SUBTYPE_STA_MAX_CONN_RETRY = 0x14;
export const BLUFI_TYPE_DATA_SUBTYPE_STA_CONN_END_REASON = 0x15;
export const BLUFI_TYPE_DATA_SUBTYPE_STA_CONN_RSSI = 0x16;

// packet frame control masks
export const BLUFI_FC_ENC_MASK = 0x01;
export const BLUFI_FC_CHECK_MASK = 0x02;
export const BLUFI_FC_DIR_MASK = 0x04;
export const BLUFI_FC_REQ_ACK_MASK = 0x08;
export const BLUFI_FC_FRAG_MASK = 0x10;

// packet frame control values
export const BLUFI_FC_ENC = 0x01;
export const BLUFI_FC_CHECK = 0x02;
export const BLUFI_FC_DIR_P2E = 0x00;
export const BLUFI_FC_DIR_E2P = 0x04;
export const BLUFI_FC_REQ_ACK = 0x08;
export const BLUFI_FC_FRAG = 0x10;

// Wifi OpMode   (from components\esp_wifi\include\esp_wifi_types.h)
export const WIFI_MODE_NULL = 0;
export const WIFI_MODE_STA = 1;
export const WIFI_MODE_AP = 2;
export const WIFI_MODE_APSTA = 3;
export const WIFI_MODE_NAN = 4;
export const WIFI_MODE_MAX = 5;
